import { Box } from '@rocket/ui';
import { useEffect } from 'react';

/**
 * PlaybookSetupGuideEmbed - Embeds an interactive Guideflow tutorial for playbook setup
 */
export function PlaybookSetupGuideEmbed() {
  useEffect(() => {
    // Load Guideflow script dynamically
    const script = document.createElement('script');
    script.src = 'https://app.guideflow.com/assets/opt.js';
    script.setAttribute('data-iframe-id', 'lpxx4zja1p');
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <Box
      position="relative"
      paddingBottom="calc(60.66838046272493% + 47px)"
      height="0"
      width="100%"
    >
      <Box
        as="iframe"
        id="lpxx4zja1p"
        width="100%"
        height="100%"
        position="absolute"
        top="0"
        left="0"
        border="none"
        css={{
          overflow: 'hidden',
        }}
        {...({
          src: 'https://app.guideflow.com/embed/lpxx4zja1p',
          scrolling: 'no',
          allow: 'clipboard-read; clipboard-write',
          allowFullScreen: true,
        } as React.IframeHTMLAttributes<HTMLIFrameElement>)}
      />
    </Box>
  );
}
